import { Component } from '@angular/core';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';

@Component({
    selector: 'snowflake-connector-panel',
    templateUrl: './snowflake.connector.panel.html'
})
export class SnowflakeConnectorPanel extends ACDATAConnectorPanel {
    PKOptions = ["USER", "MACHINE", "PFXFILE", "PFXBLOB", "JKSFILE", "JKSBLOB", "PEMKEY_FILE", "PEMKEY_BLOB", "PUBLIC_KEY_FILE",
        "PUBLIC_KEY_BLOB", "SSHPUBLIC_KEY_FILE", "SSHPUBLIC_KEY_BLOB", "P7BFILE", "PPKFILE", "XMLFILE", "XMLBLOB"];

    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Snowflake',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.SnowflakeInfo',
            ControlType: SnowflakeConnectorPanel,
            Default: {
                AuthType: 0,
                PrivateKeyType: "USER"
            }
        };
    }
}
